import script from "./DropSpot.vue?vue&type=script&setup=true&lang=js"
export * from "./DropSpot.vue?vue&type=script&setup=true&lang=js"

import "./DropSpot.vue?vue&type=style&index=0&id=fecb836c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fecb836c"]])

export default __exports__